/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".login-bg[_ngcontent-%COMP%]{background:url(listing-bg.a19da8dc3fb33d8b6f32.png) center/cover no-repeat;width:100%;height:800px}.login-bg[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#444;text-align:center}.login-bg[_ngcontent-%COMP%]   .loging-register-dialog[_ngcontent-%COMP%]{background-color:#fff;padding:30px}"];
export { styles as styles };
